(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
import React from 'react';
import { Helmet } from 'react-helmet';
import '../assets/styles/components/RoommateFinder.scss';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/scroll-to-top';
import FormRoommateFinder from '../components/FormRoommateFinder';
import ImageWebp from '../components/custom/ImageWebp';
import imgRoommateFinder from '../assets/static/tops/roommate-finder.png';
class RoommateFinder extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Find a Roommate to share your Student Housing near USC"), /*#__PURE__*/React.createElement("meta", {
      name: "description",
      content: "Need help finding a roommate near USC? Put in your application now, let us know what building you are interested in, and we can match you up with a roommate."
    })), /*#__PURE__*/React.createElement(ScrollToTop, null), /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement("main", {
      id: "content",
      className: "bypass-block-target main-content container padding-top-inner padding-bottom-inner",
      tabIndex: "-1"
    }, /*#__PURE__*/React.createElement("header", {
      className: "roommatefinder-grid"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "h1 roommatefinder-grid__heading"
    }, /*#__PURE__*/React.createElement("span", {
      className: "h1__span"
    }, "ROOMMATE"), " ", /*#__PURE__*/React.createElement("br", null), "FINDER"), /*#__PURE__*/React.createElement(ImageWebp, {
      src: imgRoommateFinder,
      alt: "LiveCBM Roommate Finder",
      className: "img-fluid roommatefinder-grid__picture--image",
      classNamePictureTag: "roommatefinder-grid__picture",
      width: "655",
      height: "445"
    }), /*#__PURE__*/React.createElement("p", {
      className: "roommatefinder-grid__paragraph"
    }, "Need help finding a roommate? Let us assist you. Put in your application now, let us know what building and unit you are interested in, and we can match you up with a roommate or roommates to make your rent even more budget friendly. Just answer the questions to get started."), /*#__PURE__*/React.createElement("div", {
      className: "roommatefinder-grid__form"
    }, /*#__PURE__*/React.createElement("h2", null, "ROOMMATE REQUEST"), /*#__PURE__*/React.createElement(FormRoommateFinder, null)))), /*#__PURE__*/React.createElement(Footer, null));
  }
  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }
}
const _default = RoommateFinder;
export default _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(RoommateFinder, "RoommateFinder", "/var/www/html/websites/livecbm-com/src/frontend/pages/RoommateFinder.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/livecbm-com/src/frontend/pages/RoommateFinder.jsx");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();